
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    PUTTBDTENPOINTS_ACTION,
    ALL_PUTTBDTENPOINTS,
    ADD_PUTTBDTENPOINTS,
    ALL_PUTTBDTENPUTTS,
    ADD_PUTTBDTENPUTTS,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Putt broadie Drill 10FT Actions
 */

    export const stdBDTenPoints = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }
        return (dispatch) => { 
            dispatch({ type:PUTTBDTENPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentputtbdtenpoint', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data;
                
                dispatch({ type: ALL_PUTTBDTENPOINTS, payload: alldata.data }); 
                return Promise.resolve(alldata);
            });
        
        }
    }

    export const addBDTenPoints = (student, startdate, enddate, data, sepmore) =>{
        
        var payload={
            "startdate":startdate,
            "enddate":enddate,
            "totval":1,
            "student":student,
            "shtot_1":sepmore,
        }
        

        for (let i = 0; i<sepmore; i++) {   
           
            var putdate='puttdate_'+i;            
            var putdateval=data.target[putdate].value;
            var putpoint='noputt_'+i;            
            var putpointval=data.target[putpoint].value;                   
            
            var adval=i+1;            
            var dateadd='puttdate_1_'+adval;  
            var puttadd='noputt_1_'+adval;             
           
            payload[dateadd]=putdateval;
            payload[puttadd]=putpointval;          
    
        }        

        return (dispatch) => { 
            dispatch({ type:PUTTBDTENPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addputtbdtenpoint', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                   
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PUTTBDTENPOINTS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const stdBDTenPutts = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:PUTTBDTENPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentputtbdtenputt', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data;
                
                dispatch({ type: ALL_PUTTBDTENPUTTS, payload: alldata.data }); 
                return Promise.resolve(alldata);
            });
        
        }
    }

    export const addBDTenPutts = (student, startdate, enddate, data, sepmore) =>{
        
        var payload={
            "startdate":startdate,
            "enddate":enddate,
            "totval":1,
            "student":student,
            "shtot_1":sepmore,
        }
        

        for (let i = 0; i<sepmore; i++) {   
           
            var putdate='puttdate_'+i;            
            var putdateval=data.target[putdate].value;
            var putpoint='noputt_'+i;            
            var putpointval=data.target[putpoint].value;                   
            
            var adval=i+1;            
            var dateadd='puttdate_1_'+adval;  
            var puttadd='noputt_1_'+adval;             
           
            payload[dateadd]=putdateval;
            payload[puttadd]=putpointval;          
    
        }        

        return (dispatch) => { 
            dispatch({ type:PUTTBDTENPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addputtbdtenputt', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                   
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PUTTBDTENPUTTS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


